import { useSelector } from 'react-redux';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { getUseCaseLimitation } from '@src/components/common/Dashboard/UseCases/limitation';

export const useExcludeMetricCategories = (defaultExcludeCategories?: string[]) => {
  const { usecaseKey } = useSelector(activeDashboardSelector);
  const limitation = getUseCaseLimitation(usecaseKey);
  const categories = defaultExcludeCategories ?? [];

  if (limitation) {
    const { excludeCategories = [] } = limitation?.metrics || {};
    categories.push(...excludeCategories);
  }

  return categories;
};
